import { useBranding } from '@/outlets/branding-outlet';
import { HostedPciPaymentPage } from './hostedpci/hostedpci-payment-page';
import { DefaultPaymentPage } from './default/default-payment-page';
import { Button } from '@/components/button';
import { Modal, ModalButtonContainer } from '@/components/modal/modal';
import { useTranslation } from '@/contexts/i18n-context';
import { useState } from 'react';
import styles from './payment-page.module.css';
import { useLocation } from '@/util/react-router-dom';
import { SuccessCircleSvg } from '@/components/svgs/success-circle';
import { useUpdateEncountersStatus } from '@/api/update-encounter-status';
import { useEncounter } from '@/contexts/encounter-context';
import { EncounterStatusIdsType } from '@/api/api.schemas';

const translationBase = 'visit.payment.modal';

export function PaymentPage() {
  const { encounter, invalidateEncounter } = useEncounter();
  const { useHostedPciPayment } = useBranding();
  const { t } = useTranslation();
  const location = useLocation();
  const { mutateAsync: updateEncounterStatus, isPending } = useUpdateEncountersStatus();
  const [isValidationSuccess, setIsValidationSuccess] = useState(
    location.state?.isValidated ?? false,
  );

  const handleValidationModalClose = async () => {
    if (isPending) return;

    if (encounter.statusId === EncounterStatusIdsType.PreSubmitIdentityVerification) {
      await updateEncounterStatus({
        encounterId: encounter.id,
        data: { statusId: EncounterStatusIdsType.PreSubmitPaymentInfo },
      });
      invalidateEncounter();
    }
    setIsValidationSuccess(false);
  };

  return (
    <>
      {useHostedPciPayment ? <HostedPciPaymentPage /> : <DefaultPaymentPage />}
      <Modal
        className={styles.modal}
        isOpen={isValidationSuccess}
        closeOnOutsideClick={!isPending}
        onClose={handleValidationModalClose}
      >
        <SuccessCircleSvg className={styles.modalIcon} />
        <h2 className="h3">{t(`${translationBase}.title`)}</h2>
        <ModalButtonContainer className={styles.buttonContainer}>
          <Button
            onClick={handleValidationModalClose}
            rightIcon="arrow_forward"
            loading={isPending}
            disabled={isPending}
          >
            {t(`${translationBase}.continue`)}
          </Button>
        </ModalButtonContainer>
      </Modal>
    </>
  );
}
